import { SubSectionHeader } from '@/pages/CompanyReport/components/Overview/components/SubSectionHeader';
import { CompanyNarrativesCreateButton } from './CompanyNarrativesCreateButton';

type Props = {
  companyId?: string;
  uniqueSymbol?: string;
};

export const CompanyNarrativesHeader = ({ companyId, uniqueSymbol }: Props) => {
  return (
    <header className="grid grid-cols-[1fr_max-content] justify-between gap-x1">
      <SubSectionHeader data-cy-id="company-narratives-heading">
        Community vs My Fair Value
      </SubSectionHeader>
      {!!companyId && !!uniqueSymbol && (
        <CompanyNarrativesCreateButton
          companyId={companyId}
          uniqueSymbol={uniqueSymbol}
          variant="outline"
        />
      )}
    </header>
  );
};
